import { findPageSizePreset, pageSizeToPx } from "../constants/pageDimensions";
import { createBoardCells, normalizeStoryboard } from "../constants/storyboard";
import { trackEvent } from "./analytics";

/**
 * Download a template as a blank, printable one-page PDF, drawn by the same
 * renderer as the editor's exports.
 */
export const downloadBlankBoardPDF = async (template) => {
  const { seed, slug } = template;
  const { width, height } = pageSizeToPx(findPageSizePreset(seed.pageSizeKey));
  const storyboard = normalizeStoryboard(seed.storyboard);
  const cells = createBoardCells({ pageWidth: width, pageHeight: height, storyboard });
  const { exportProjectToPDF } = await import("./pdfExport");
  await exportProjectToPDF(
    [{ cells, pageWidthPx: width, pageHeightPx: height, comicStyleKey: seed.comicStyleKey, storyboard }],
    `striply-storyboard-template-${slug}`,
    { dpi: 200 }
  );
  trackEvent("storyboard_template_pdf", { slug });
};
